export const environment = {
    production: false,
    firebase: {
        apiKey: 'AIzaSyDUx1F74v7AIwAKAa5pSyF0scXM0O_caus',
        authDomain: 'lupino-4f050.firebaseapp.com',
        projectId: 'lupino-4f050',
        storageBucket: 'lupino-4f050.appspot.com',
        messagingSenderId: '581519864630',
        appId: '1:581519864630:web:80d70f451ee25960653997'
    },
    apiUrl : 'https://dev.api.lupino.fr'

};
